// @flow
import React from 'react';

import Zap from 'app/get-help/components/blocks/Zap/Zap';
import { base } from 'app/get-help/utils/tree';

import type { NodeDefinition } from 'app/get-help/utils/tree/types';

// kind only accepts an array containing element(s) 'workflow' (other kind 'transfer' was deprecated)
// KindDisplayName only accepts the string(s) 'Zap' ('Transfer' was deprecated)
// but flow exact types won't reflect this
export type NodeOptions = {|
  title: string,
  instructions: string,
  disableIncidents?: boolean,
  isRequired?: boolean,
  child: NodeDefinition,
  kind: string[],
  kindDisplayName: string,
|};

const zap = (options: NodeOptions): NodeDefinition => {
  const node = base({
    id: 'zap',
    isRequired: false,
    children: {
      [options.child.id]: options.child,
    },
    hasData: data => {
      // `null` means they skipped
      return data || data === null;
    },
    getNextNode: () => {
      return options.child;
    },
    render: nodes => {
      return (
        <Zap
          {...nodes}
          disableIncidents={options.disableIncidents === true}
          instructions={options.instructions}
          kind={options.kind}
          kindDisplayName={options.kindDisplayName}
          title={options.title}
        />
      );
    },
    export: data => ({
      id: node.id,
      data: data && parseInt(data.id),
      label: options.title,
    }),
  });

  return node;
};

export default zap;
